import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../hooks/redux';
import { User } from '../../types/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    // Redirect to appropriate dashboard based on role
    const dashboardPath = getRoleDashboard(user);
    return <Navigate to={dashboardPath} replace />;
  }

  return <>{children}</>;
};

const getRoleDashboard = (user: User): string => {
  switch (user.role) {
    case 'manager':
      return '/dashboard';
    case 'executive1':
      return '/orders';
    case 'executive2':
      return '/stock-entry';
    case 'worker':
      return '/picking';
    default:
      return '/dashboard';
  }
};

export default ProtectedRoute;
